var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demographicInterest"},[_c('adx-list-item',{attrs:{"data":_vm.data,"type":"bar"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }